<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="5" :sm="24">
            <a-form-item label="项目">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-model="queryParam.project_id"
                placeholder="请输入项目"
                :default-active-first-option="false"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-select-option v-for="d in projectList" :key="d.id" :tt="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="付款方式">
              <div class="custom-select-container">
                <a-select
                  allow-clear
                  placeholder="付款方式"
                  v-model="queryParam.payment_method"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_credit_letter_payment_method">{{ val }}</a-select-option>
                </a-select>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="true">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="lc_amount_render" slot-scope="text, record" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }} （{{ $Dictionaries.currency[record.lc_amount_currency] || '' }}）
      </div>
      <div slot="margin_amount_render" slot-scope="text, record" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }}（{{ $Dictionaries.currency[record.margin_amount_currency] || '' }}）
      </div>
      <div slot="margin_interest_rate_render" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(2) | numberFormat }} %
      </div>
      <span slot="approval_needed" slot-scope="text">
        <span class="desc">{{ text ? '是' : '否' }}</span>
      </span>
      <span slot="is_lc_acceptanced" slot-scope="text, item">
        <a-popconfirm
          title="确定承兑吗?"
          :disabled="text"
          @confirm="() => doAcceptance(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_lc_acceptanced" :disabled="item.is_lc_acceptanced"/>
        </a-popconfirm>
      </span>
      <span slot="is_audited" slot-scope="text, item">
        <a-popconfirm
          :title="auditTitle"
          @confirm="() => doAudit(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_audited"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleAttachment(record)">附件</a>
          <a-divider type="vertical" v-if="!record.is_audited"/>
          <a @click="handleEdit(record)" v-if="!record.is_audited">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <archived-form
      ref="archivedModal"
      v-if="archived_visible"
      :visible="archived_visible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import CreateForm from '../modules/CreateForm'
import ArchivedForm from '../modules/ArchivedForm'
import {
  credit_letter_archived,
  lc_application_list,
  lc_issuance_list,
  lc_issuance_create,
  lc_issuance_update,
  lc_issuance_delete
} from '@/api/trade_credit_letter'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'
import { client_list } from '@/api/trade_client'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    ArchivedForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.clientSearch = debounce(this.handleClientSearch, 800)
    return {
      approval_again: false,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archived_visible: false,
      mdl: {},
      projectList: [],
      clientList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '项目',
          dataIndex: 'project',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '业务号',
          dataIndex: 'business_no',
          width: 150,
          ellipsis: true
        },
        {
          title: '开证行',
          dataIndex: 'issuing_bank',
          width: 180,
          ellipsis: true
        },
        {
          title: '代开银行',
          dataIndex: 'debtor_bank',
          width: 180,
          ellipsis: true
        },
        {
          title: '上游客户',
          dataIndex: 'beneficiary',
          width: 180,
          ellipsis: true
        },
        {
          title: '开证日',
          dataIndex: 'issue_date',
          width: 120,
          ellipsis: true
        },
        {
          title: '开证金额',
          dataIndex: 'lc_amount',
          scopedSlots: { customRender: 'lc_amount_render' },
          align: 'right',
          width: 160,
          ellipsis: true
        },
        {
          title: '溢短装（%）',
          dataIndex: 'more_less_clause',
          width: 140,
          align: 'right',
          ellipsis: true
        },
        {
          title: '保证金金额',
          dataIndex: 'margin_amount',
          scopedSlots: { customRender: 'margin_amount_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '保证金存入日期',
          dataIndex: 'margin_deposit_date',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '保证金到期日',
          dataIndex: 'margin_maturity_date',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '保证金利率',
          dataIndex: 'margin_interest_rate',
          scopedSlots: { customRender: 'margin_interest_rate_render' },
          align: 'right',
          width: 120,
          ellipsis: true
        },
        {
          title: '是否到期可用',
          dataIndex: 'is_available_at_expiry',
          ellipsis: true,
          align: 'center',
          width: 120,
          customRender: (text) => text ? '是' : '否'
        },
        {
          title: '信用证种类',
          dataIndex: 'lc_type',
          align: 'center',
          width: 100,
          customRender: (text) => this.$Dictionaries.trade_lc_types[text] || '无'
        },
        {
          title: '期限（天）',
          dataIndex: 'lc_tenor',
          width: 150,
          align: 'right',
          ellipsis: true
        },
        {
          title: '是否已承兑',
          dataIndex: 'is_lc_acceptanced',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'is_lc_acceptanced' }
        },
        {
          title: '是否已核验',
          dataIndex: 'is_audited',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'is_audited' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '210px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return lc_issuance_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    this.handleProjectSearch(undefined)
    this.handleClientSearch(undefined)
  },
  mounted () {
    this.loadLcApplicationData()
  },
  computed: {
    auditTitle () {
      return (item) => item ? '确定重新启动核验吗？' : '确定已经通过核验吗？'
    }
  },
  methods: {
    loadLcApplicationData () {
      lc_application_list({ id: this.$route.query.lc_application_id })
        .then(res => {
          this.mdl = res.data.entries[0] || []
          console.log('信用证开始', this.mdl)
        })
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      // const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      // const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      this.mdl = { number: year + '' + month + '' + day + '' + hours }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachment (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/credit_letter/' + record.id + '/attachment', query: { project: record.project, corporation: record.host_corporation } })
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/credit_letter/' + record.id })
    },
    handleDetail (record) {
      this.$router.push({ path: '/trade/credit_letter/' + record.id + '/detail', query: { project: record.project, corporation: record.host_corporation } })
    },
    doAcceptance (record) {
      // 去承兑
      lc_issuance_update({ is_lc_acceptanced: !record.is_lc_acceptanced }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    doAudit (record) {
      // 去承兑
      lc_issuance_update({ is_audited: !record.is_audited }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleDelete (record) {
      lc_issuance_delete(record.id).then((res) => {
        console.log(res)
        console.log('删除成功------')

        this.$refs.table.refresh()
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          values = { ...values, ...data }
          values['lc_application_id'] = this.$route.query.lc_application_id
          lc_issuance_create(values).then(res => {
              this.visible = false
              this.confirmLoading = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              if (res.code === 1000) {
                this.$refs.table.refresh()
              }
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleProjectSearch (value) {
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      }
    },
    handleClientSearch (value) {
      client_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleClientChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          credit_letter_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archived_visible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
